export default __webpack_public_path__ + "static/media/start-date.43f608b1.svg";